import { render, staticRenderFns } from "./BenefitNotificationBoxBase.vue?vue&type=template&id=5ba18525&scoped=true&"
import script from "./BenefitNotificationBoxBase.vue?vue&type=script&lang=js&"
export * from "./BenefitNotificationBoxBase.vue?vue&type=script&lang=js&"
import style0 from "./BenefitNotificationBoxBase.vue?vue&type=style&index=0&id=5ba18525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba18525",
  null
  
)

export default component.exports